<template>
  <div>
    <Navbar/>

    <section>
      <h2>Πολιτική Απορρήτου</h2>
      <div class="privacy-container">
        <div class="bussiness-specs">
          <p class="p-align mt-1">
            Στην SLM θέλουμε οι αποστολείς και οι παραλήπτες των ταχυδρομικών αντικειμένων, να γνωρίζουν και να έχουν 
            έλεγχο στο ποια δεδομένα τους μοιράζονται μαζί μας και στο τι κάνουμε εμείς με αυτά. Το κείμενο αυτό (που 
            ονομάζεται Πολιτική Απορρήτου) εξηγεί με απλά λόγια αλλά και σαφήνεια τι δεδομένα συλλέγουμε για εσάς στο 
            πλαίσιο λειτουργίας των υπηρεσιών μας και πώς τα χρησιμοποιούμε, σύμφωνα με το περιεχόμενο του Κανονισμού 
            (ΕΕ) 2016/679, όπως επίσης των Ν.4624/2019 και Ν.2472/1997, όπως εκάστοτε ισχύουν.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Υπεύθυνος Επεξεργασίας</h5>
          <p class="p-align mt-1">
            Η εταιρία «ΣΚΡΟΥΤΖ ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΜΟΝΟΠΡΟΣΩΠΗ Α.Ε.» [εφεξής «SLM» ή «εμείς»] 
            με έδρα στην Οδό Αγίας Άννης αρ. 7, Τ.Κ. 118 55 Αθήνα, URL:
            <a href="https://www.skroutzlastmile.gr/">https://www.skroutzlastmile.gr/</a>, και με ΑΦΜ 801238128,
            είναι σύμφωνα με το νόμο υπεύθυνη για την
            επεξεργασία των προσωπικών δεδομένων των αποστολέων και των παραληπτών, στο πλαίσιο της παροχής ταχυδρομικών 
            υπηρεσιών [εφεξής «Υπηρεσίες SLM»]. Συγκεκριμένα, οι υπηρεσίες αυτές περιλαμβάνουν τη συμβατική σχέση που 
            αναπτύσσουμε με τους αποστολείς και τους παραλήπτες στο πλαίσιο της διεκπεραίωσης της παραγγελίας από την 
            παραλαβή του ταχυδρομικού αντικειμένου έως την εναπόθεση αυτού.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Προσωπικά Δεδομένα που Συλλέγουμε</h5>
          <p class="p-align mt-1">
            Στο πλαίσιο παροχής των Υπηρεσιών SLM, είναι πιθανόν να συλλέγουμε και επεξεργαζόμαστε περαιτέρω τα ακόλουθα
            προσωπικά σας δεδομένα:
            <ul>
              <li>Στοιχεία ταυτοποίησης, όπως ονοματεπώνυμο του αποστολέα/παραλήπτη, καθώς και, ειδικά για τον αποστολέα,
                αριθμός Δελτίου Ταυτότητας ή αριθμός διαβατηρίου σε περίπτωση φυσικού προσώπου, ή αριθμός φορολογικού
                μητρώου (ΑΦΜ) και αριθμός ΓΕΜΗ σε περίπτωση νομικού προσώπου
              </li>
              <li>Στοιχεία επικοινωνίας, όπως διευθύνσεις email, πλήρη ταχυδρομική διεύθυνση, αριθμό τηλεφώνου</li>
              <li>Πληροφορίες που αφορούν στο είδος της παρεχόμενης υπηρεσίας</li>
              <li>Στοιχεία που αφορούν στο ποσό της τυχόν καταβληθείσας αντικαταβολής αλλά και την ημερομηνία/ώρα πληρωμής</li>
              <li>Στοιχεία που σχετίζονται με το διακινούμενο ταχυδρομικό αντικείμενο, όπως ο αριθμός παραγγελίας, ο κωδικός 
                του ταχυδρομικού αντικειμένου, το είδος και το βάρος του ταχυδρομικού αντικειμένου, αλλά και τυχόν 
                κατηγοριοποίηση αυτού ως απολεσθέν ή ανεπίδοτο
              </li>
              <li>Στοιχεία που σχετίζονται με τη διακίνηση του ταχυδρομικού αντικειμένου, όπως ημερομηνία/ώρα/τοποθεσία της 
                παραλαβής, αναχώρησης/παραλαβής από το κέντρο διαλογής, της αναμενόμενης παράδοσης, της αποτυχημένης 
                παράδοσης και της αναπρογραμματισμένης παράδοσης, της προγραμματισμένης επιστροφής, της επιστροφής στον 
                αποστολέα και εν γένει πάσης φύσεως timestamps (σημειώσεις χρόνου) που ενδέχεται να προκύψουν από το 
                σύστημα παρακολούθησης της αποστολής, αλλά και κάθε άλλη πληροφορία σχετιζόμενη με τη μεταφορά του φακέλου/δέματος
              </li>
              <li>Στοιχεία που αφορούν στην επικοινωνία μαζί μας, όπως το περιεχόμενο της επικοινωνίας, το περιεχόμενο του SMS/Viber 
                μηνύματος που λαμβάνετε, ή/και οποιοδήποτε σχετικό αίτημα προς εμάς, όπως π.χ. αίτημα επιστροφής του ταχυδρομικού αντικειμένου
              </li>
              <li>Στοιχεία που αφορούν σε κάποιο αίτημα αποζημίωσης, όπως η αιτία και το ποσό της αποζημίωσης, στοιχεία τραπεζικού λογαριασμού, 
                όπως αριθμός λογαριασμού, ΙΒΑΝ, ονομασία δικαιούχου, τυχόν πόρισμα της Επιτροπής Επίλυσης Διαφορών, τυχόν φωτογραφίες του 
                κατεστραμμένου ταχυδρομικού αντικειμένου
              </li>
              <li>Πληροφορίες που συλλέγουμε μέσω τεχνολογικών λύσεων, όπως τα cookies, η διεύθυνση IP, τεχνικές πληροφορίες σύνδεσης της 
                συσκευής σας, στοιχεία ανάλυσης χρήσης της ιστοσελίδας μας
              </li>
            </ul>
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Γιατί τα συλλέγουμε</h5>
          <p class="p-align mt-1">
            Τα παραπάνω προσωπικά σας δεδομένα γίνονται αντικείμενο επεξεργασίας από εμάς αποκλειστικά για την εξυπηρέτηση των παρακάτω 
            σκοπών και σύμφωνα με τις ακόλουθες νόμιμες βάσεις:
          </p>
        </div>
        <div class="bussiness-specs">
          <h5><u>Σύμβαση</u></h5>
          <p class="p-align mt-1 ml-1">
            Η SLM επεξεργάζεται τα δεδομένα σας στο πλαίσιο της εκτέλεσης της σύμβασης αναφορικά με τη διεκπεραίωση της αποστολής του 
            ταχυδρομικού αντικειμένου που συνάπτει μαζί σας.
          </p>
          <p class="p-align mt-1 ml-1">
            Συγκεκριμένα, επεξεργαζόμαστε τα στοιχεία σας για να διεκπεραιώσουμε προσηκόντως την αποστολή, και ειδικότερα στο πλαίσιο 
            της παραλαβής και της εναπόθεσης του ταχυδρομικού αντικειμένου, αλλά και στο πλαίσιο της διαχείρισης των 
            απολεσθέντων/ανεπίδοτων και των επιστροφών στον αποστολέα. Επεξεργαζόμαστε, επίσης, τα στοιχεία σας στο πλαίσιο της 
            επικοινωνίας που μπορεί να έχετε μαζί μας, αλλά και κατά την ενημέρωσή σας αναφορικά με το στάδιο στο οποίο βρίσκεται 
            το ταχυδρομικό αντικείμενο ή σχετικά με τυχόν αποτυχία παράδοσης. Τέλος, τα στοιχεία σας γίνονται αντικείμενο επεξεργασίας 
            στο πλαίσιο της συλλογής, αποτύπωσης και κατάθεσης των αντικαταβολών.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5><u>Έννομο Συμφέρον</u></h5>
          <p class="p-align mt-1 ml-1">
            Αποτελεί έννομο συμφέρον της SLM να επεξεργάζεται τα στοιχεία σας στο πλαίσιο της αποτύπωσης του όγκου των παραγγελιών 
            που διεκπεραιώθηκαν για σκοπούς τιμολόγησης και οικονομικής εκκαθάρισης με τους πελάτες της, αλλά και κατά την εκπόνηση 
            των καθημερινών ελέγχων της αποθήκης. Επίσης, είναι στο έννομο συμφέρον της SLM η αποθήκευση των στοιχείων σας για 
            ιστορικούς/backup λόγους αλλά και για τη διαχείριση, την αποτροπή και την αντίδραση σε περιστατικά ασφαλείας. Τέλος, 
            αποτελεί έννομο συμφέρον της SLM να επεξεργάζεται τα στοιχεία σας στο πλαίσιο της διαχείρισης νομικών αξιώσεων, στις 
            οποίες εμπλέκεται η εταιρεία, αλλά και στο πλαίσιο αναζήτησης νομικών συμβουλών.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5><u>Νομική Υποχρέωση</u></h5>
          <p class="p-align mt-1 ml-1">
            Η SLM είναι υποχρεωμένη από τη νομοθεσία να συνεργάζεται με τις αρμόδιες αρχές, ιδίως κατόπιν αιτημάτων τους, για την 
            καταπολέμηση συγκεκριμένων περιστατικών που αφορούν σε άρση του απορρήτου των επικοινωνιών ή λοιπές παραβάσεις της 
            νομοθεσίας. Είμαστε επίσης υποχρεωμένοι από τη νομοθεσία να διαχειριζόμαστε και να απαντούμε στα αιτήματά σας που 
            αφορούν στην προστασία των προσωπικών σας δεδομένων και στα αιτήματα σας για αποζημίωση σύμφωνα με το κανονιστικό 
            πλαίσιο, όπως εκάστοτε ισχύει.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5><u>Συγκατάθεση</u></h5>
          <p class="p-align mt-1 ml-1">
            Εφόσον δώσετε τη συγκατάθεσή σας για τη χρήση τεχνολογιών όπως τα cookies στη συσκευή σας, συλλέγεται αυτόματα 
            πληροφορία για εσάς, σύμφωνα με την <router-link to="/cookies" class="strong">Πολιτική Cookies</router-link> της SLM. Μπορείτε ανά πάσα στιγμή να αλλάξετε την επιλογή 
            σας για τα cookies και να αποσύρετε τη συγκατάθεσή σας, στο κάτω μέρος της Πολιτικής Cookies της SLM.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Με Ποιους τα Μοιραζόμαστε</h5>
          <p class="p-align mt-1">
            Τα προσωπικά δεδομένα σας, συλλέγονται και γίνονται αντικείμενο περαιτέρω επεξεργασίας από την εξουσιοδοτημένη 
            για αυτό ομάδα της SLM, με πλήρη σεβασμό στην ιδιωτικότητά σας. Στο πλαίσιο της παροχής των Υπηρεσιών SLM, 
            αποδέκτες των προσωπικών σας δεδομένων μπορεί να είναι οι ακόλουθες κατηγορίες αποδεκτών:
            <ul>
              <li>Η μητρική εταιρεία Skroutz S.A. καθώς και άλλες εταιρείες του Ομίλου Σκρουτζ, για τη διεκπεραίωση
                υποστηρικτικών λειτουργιών των Υπηρεσιών μας.
              </li>
              <li>Πάροχοι τεχνολογικών λύσεων, ανάπτυξης, εγκατάστασης, τεχνικής υποστήριξης και συντήρησης πληροφοριακών
                συστημάτων και εφαρμογών. Τα δεδομένα σας ενδέχεται να διαβιβαστούν εκτός Ευρωπαϊκού Χώρου και ιδίως στις ΗΠΑ
                από τις εταιρείες αυτές. Στο πλαίσιο αυτό, εφαρμόζουμε επιπλέον μέτρα προστασίας δεδομένων και ασφάλειας, όπως
                αυστηρές συμβατικές ρήτρες και τεχνική παραμετροποίηση.
              </li>
              <li>Πάροχοι υπηρεσιών επεξεργασίας, αποθήκευσης και ασφάλειας δεδομένων.</li>
              <li>Πάροχοι λογισμικών και πλατφορμών επικοινωνίας, στο πλαίσιο υλοποίησης της μεταξύ μας επικοινωνίας</li>
              <li>Τραπεζικά ιδρύματα και ιδρύματα πληρωμών, όπως η Everypay σε περίπτωση καταβολής κάποιας αποζημίωσης και για
                την οικονομική εκκαθάριση των συναλλαγών σας με την Εταιρεία.
              </li>
              <li>Συνεργαζόμενες εταιρείες παροχής υπηρεσιών αποθήκευσης και μεταφοράς προϊόντων (logistics/warehousing).</li>
              <li>Συνεργαζόμενες ταχυδρομικές επιχειρήσεις ή/και εταιρείες ταχυμεταφορών (courier), οι οποίες παρέχουν
                ταχυδρομικές υπηρεσίες και υπηρεσίες ταχυμεταφορών, υπό καθεστώς Γενικής ή Ειδικής Άδειας, σύμφωνα με τα
                οριζόμενα στον ν. 4053/2012. Για την συλλογή, επεξεργασία και τυχόν περαιτέρω διαβίβαση των προσωπικών
                στοιχείων των αποστολέων και παραληπτών, στο πλαίσιο παροχής ταχυδρομικών υπηρεσιών από τις εν λόγω
                συνεργαζόμενες επιχειρήσεις, ισχύουν οι Όροι Χρήσης και η Πολιτική Απορρήτου έκαστης εξ αυτών, τα οποία
                κείμενα είναι διαθέσιμα στην εταιρική ιστοσελίδα κάθε εταιρείας.
              </li>
              <li>Εξωτερικοί σύμβουλοι, λογιστές και δικηγόροι.</li>
              <li>Οι αστυνομικές αρχές και οποιαδήποτε άλλη διοικητική, δικαστική ή δημόσια αρχή ή γενικά νομικό ή φυσικό 
                πρόσωπο προς το οποίο ενδέχεται βάσει νόμου ή δικαστικής απόφασης, να απορρέει σχετική υποχρέωση ή δικαίωμα 
                της SLM να ανακοινώνει τέτοια δεδομένα.
              </li>
            </ul>
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Πόσο Καιρό τα Διατηρούμε</h5>
          <p class="p-align mt-1">
            Η SLM διατηρεί τα προσωπικά δεδομένα των αποστολέων και των παραληπτών μόνο για το χρονικό διάστημα που απαιτείται για
            την εκπλήρωση των ανωτέρω σκοπών και για τη συμμόρφωσή της με την κείμενη νομοθεσία.
          </p>
          <p class="p-align mt-1">
            Μετά το πέρας της περιόδου αυτής και στην περίπτωση που δεν εκκρεμεί κάποια οικονομική οφειλή, δικαστική ή άλλη αμφισβήτηση
            ή ειδικό έννομο συμφέρον που να απορρέει από τη συμβατική σας σχέση μαζί μας, τα δεδομένα θα διαγράφονται με ασφαλή τρόπο ή
            θα ανωνυμοποιούνται.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Οι Δεσμεύσεις μας</h5>
          <p class="p-align mt-1">
            Λαμβάνουμε καθημερινά τα κατάλληλα τεχνικά και οργανωτικά μέτρα, σύμφωνα με τα τελευταία τεχνολογικά πρότυπα και την ισχύουσα 
            νομοθεσία, προκειμένου να διασφαλίσουμε ότι η επεξεργασία των προσωπικών δεδομένων, είτε από εμάς είτε από τρίτα μέρη για 
            λογαριασμό μας, είναι σύννομη, ενδεδειγμένη και διαθέτει το κατάλληλο επίπεδο ασφάλειας για να αποτρέψει κάθε μη εξουσιοδοτημένη 
            ή τυχαία πρόσβαση, επεξεργασία, διαγραφή, αλλοίωση ή άλλη χρήση αυτών.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Τα Δικαιώματά σας</h5>
          <p class="p-align mt-1">
            Μπορείτε να ελέγξετε, να διορθώσετε ή/και να διαγράψετε τα δεδομένα σας ανά πάσα στιγμή, στέλνοντάς μας σχετικό αίτημα. 
            Γενικότερα, σύμφωνα με τη νομοθεσία για την προστασία προσωπικών δεδομένων έχετε και μπορείτε να ασκήσετε τα ακόλουθα δικαιώματα, 
            μετά από εξακρίβωση της ταυτότητάς σας:
            <ul>
              <li><span class="strong">το δικαίωμα πρόσβασης,</span> το δικαίωμα δηλαδή αφενός να ενημερωθείτε για το κατά πόσον τα προσωπικά σας δεδομένα υφίστανται 
                επεξεργασία από την SLM και αφετέρου να λάβετε περαιτέρω πληροφορίες σχετικά με την πραγματοποιούμενη επεξεργασία,
              </li>
              <li><span class="strong">το δικαίωμα να ζητήσετε τη διόρθωση</span> τυχόν ανακριβών προσωπικών σας δεδομένων ή τη συμπλήρωση αυτών,</li>
              <li><span class="strong">το δικαίωμα διαγραφής,</span> το δικαίωμα δηλαδή να ζητήσετε την ολική διαγραφή των προσωπικών δεδομένων
                σας, υπό ορισμένες προϋποθέσεις,
              </li>
              <li><span class="strong">το δικαίωμα φορητότητας,</span> το δικαίωμα δηλαδή να λάβετε και να διαβιβάσετε σε άλλον υπεύθυνο επεξεργασίας τα προσωπικά 
                δεδομένα σας, τα οποία έχετε δώσει στην SLM, σε κατάλληλο μορφότυπο,
              </li>
              <li><span class="strong">το δικαίωμα περιορισμού</span> της επεξεργασίας, το δικαίωμα δηλαδή να ζητήσετε περιορισμό στην χρήση
                και επεξεργασία των δεδομένων σας, εάν θεωρείτε ότι τα δεδομένα σας δεν είναι ακριβή, ή η επεξεργασία τους είναι
                παράνομη ή θεωρείτε ότι δεν μας χρειάζονται πλέον, ή έχετε αντιρρήσεις ως προς επεξεργασία τους,
              </li>
              <li><span class="strong">το δικαίωμα εναντίωσης</span>, ιδίως αναφορικά με τις επεξεργασίες που βασίζονται στο έννομο συμφέρον μας,</li>
              <li><span class="strong">το δικαίωμα να ανακαλέσετε ανά πάσα στιγμή τη συγκατάθεση που τυχόν μας έχετε δώσει,</span> οποτεδήποτε,
                χωρίς αιτιολόγηση και χωρίς η ανάκληση αυτή να θίγει τη νομιμότητα της επεξεργασίας προσωπικών δεδομένων που
                πραγματοποιήθηκε πριν την ημερομηνία ανάκλησης αυτής.
              </li>
            </ul>
          </p>
          <p class="p-align mt-1">
            Σημειώνουμε ότι η άσκηση ή/και ικανοποίηση των ανωτέρω δικαιωμάτων υπόκειται στους όρους και προϋποθέσεις και τυχόν
            περιορισμούς που ορίζει ο νόμος.
          </p>
          <p class="p-align mt-1">
            Σε περίπτωση άσκησης των δικαιωμάτων διόρθωσης, διαγραφής και περιορισμού των δεδομένων σας, τα αιτήματα αυτά θα διαβιβάζονται και στους τρίτους 
            αποδέκτες στους οποίους τα δεδομένα αυτά τυχόν γνωστοποιήθηκαν από εμάς, στο πλαίσιο παροχής των ταχυδρομικών υπηρεσιών.
          </p>
          <p class="p-align mt-1">
            Η άσκηση των ανωτέρω δικαιωμάτων σας γίνεται με υποβολή σχετικού έγγραφου ή/και ηλεκτρονικού αιτήματός σας προς τη SLM, στο οποίο αναλαμβάνουμε να απαντήσουμε 
            εντός προθεσμίας ενός (1) μήνα από την παραλαβή του. Η προθεσμία αυτή μπορεί να παραταθεί για δύο (2) επιπλέον μήνες εξαιτίας πολυπλοκότητας 
            του αιτήματός, ή/και του μεγάλου όγκου των αιτημάτων.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Στοιχεία Επικοινωνίας</h5>
          <p class="p-align mt-1">
            Για οποιαδήποτε απορία, διευκρίνιση ή αίτημά σας <span class="strong"><u>αποκλειστικά</u></span> για την επεξεργασία των προσωπικών δεδομένων σας, 
            παρακαλούμε όπως επικοινωνείτε με τον υπεύθυνο προστασίας προσωπικών δεδομένων της SLM:
          </p>
          <p class="p-align mt-1">
            ΣΚΡΟΥΤΖ ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΜΟΝΟΠΡΟΣΩΠΗ Α.Ε., Υπόψιν: Data Protection Officer, Αγίας Άννης 7, Τ.Κ. 118 55 Αθήνα | 
            <a href="mailto:dpo@skroutzdelivery.gr">dpo@skroutzdelivery.gr</a> .
          </p>
          <p class="p-align mt-1">
            Για επικοινωνία <span class="strong">σχετικά με την αποστολή του πακέτου σας μέσω Skroutz,</span>
            παρακαλούμε επικοινωνείτε μέσω <a href="mailto:help@skroutzdelivery.gr">help@skroutzdelivery.gr</a>.
          </p>
          <p class="p-align mt-1">
            Για επικοινωνία <span class="strong">σχετικά με την αποστολή του πακέτου σας εκτός Skroutz</span> παρακαλούμε για επικοινωνία στο
            <a href="mailto:externalhelp@skroutzdelivery.gr">externalhelp@skroutzdelivery.gr</a>.
          </p>
          <p class="p-align mt-1">
            Για τηλεφωνική επικοινωνία καλέστε μας στο 2111982107.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Δικαίωμα Καταγγελίας</h5>
          <p class="p-align mt-1">
            Σε περίπτωση που θεωρείτε ότι δεν ικανοποιήσαμε επαρκώς το αίτημά σας και θίγεται κατά οποιονδήποτε τρόπο η προστασία των προσωπικών 
            σας δεδομένων, μπορείτε να υποβάλετε καταγγελία μέσω της <a href="https://www.dpa.gr/el/syndesi/prosvasi">ειδικής διαδικτυακής πύλης</a> 
            στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (Αθήνα, Λεωφόρος Κηφισίας 1-3, Τ.Κ. 115 23 | τηλ: +30 210 6475600). Αναλυτικές 
            οδηγίες υποβολής καταγγελίας παρέχονται στην <a href="https://www.dpa.gr/el/polites/katagelia_stin_arxi">Ιστοσελίδα</a> της Αρχής.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Τροποποίηση</h5>
          <p class="p-align mt-1">
            Η παρούσα τροποποιείται με πρωτοβουλία της SLM όταν ο νόμος ορίζει ή σύμφωνα με τις δραστηριότητες της SLM και ισχύει
            από την ανάρτησή της στην σχετική ιστοσελίδα της SLM.
          </p>
          <p class="p-align mt-1">
            <em class="strong">Τελευταία Τροποποίηση: 1/10/2026</em>
          </p>
        </div>

      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Footer from '../pages-sections/Footer.vue'
import Navbar from '../pages-sections/Navbar.vue'
export default {
  components: {
    Navbar, 
    Footer 
  },

}
</script>

<style lang="scss" scoped>
  section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: unset;
    border-radius: unset;
    
    h2 {
      font-weight: bold;
      line-height: 40px;
    }
  }
  .privacy-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: 100%;
    min-height: 600px;
    width: 100%;
    max-width: 780px;

    .p-align {
      text-align: justify;
    }
  }

  .bussiness-specs {
    margin-top: 1rem;

    h5 {
      font-weight: bold;
      font-size: 1.2em;
    }
    p {
      margin: 0.5rem 0;
    }
    ul {
      margin-left: 2rem;
      li {
        list-style-type: disc;
        margin-top: 12px;
        list-style-position: outside;
        
        &::before {
          content: "";
          display: inline-block;
        }
      }
    }
    .strong {
      font-weight: bold;
    }
  }
  .mt-1 {
    margin-top: 1rem;
  }
  .ml-1 {
    margin-left: 1rem !important;
  }
</style>
